export default "__VITE_ASSET__cjdXEoQK__"